// Shared careers data — open positions matching the official ozarkmtnco.com /employment/ list.
export const openRoles = [
  {
    title: 'Laborers',
    location: 'Conway, AR (Travel Required)',
    type: 'Full-time',
    summary: 'General construction laborers for foundation and civil projects across the United States.',
    responsibilities: [
      'Assist with site preparation, formwork, and cleanup',
      'Move materials, tools, and equipment around active job sites',
      'Support skilled trades during foundation pours and finishing',
      'Follow site safety protocols and OSHA standards at all times',
    ],
    requirements: [
      'Physical stamina for outdoor construction work in varied weather',
      'Willingness to travel to worksites across the U.S.',
      'Reliable transportation and valid ID',
      'OSHA 10 a plus; we provide training',
    ],
  },
  {
    title: 'Carpenters',
    location: 'Conway, AR (Travel Required)',
    type: 'Full-time',
    summary: 'Form carpenters for circular pedestal formwork, vaults, and concrete foundation work.',
    responsibilities: [
      'Build, set, and strip wood and metal formwork for foundations and pedestals',
      'Read blueprints and execute layouts to specification',
      'Operate hand and power tools safely and efficiently',
      'Coordinate with rod busters and concrete crews',
    ],
    requirements: [
      '2+ years form-carpentry experience preferred',
      'Willingness to travel nationwide',
      'Valid driver\u2019s license a plus',
      'OSHA 10 / OSHA 30 a plus',
    ],
  },
  {
    title: 'Rod Busters',
    location: 'Conway, AR (Travel Required)',
    type: 'Full-time',
    summary: 'Reinforcing-steel workers (rebar) for tank foundations and civil structures.',
    responsibilities: [
      'Place, tie, and secure rebar to engineered drawings',
      'Set anchor bolts and embeds to surveyed tolerances',
      'Inspect and verify reinforcement layouts before pours',
      'Maintain a safe and organized work area',
    ],
    requirements: [
      'Prior rebar / ironworker experience preferred',
      'Comfortable working at heights and in excavations',
      'Willingness to travel nationwide',
      'OSHA 10 a plus',
    ],
  },
  {
    title: 'Equipment Operators',
    location: 'Conway, AR (Travel Required)',
    type: 'Full-time',
    summary: 'Skilled operators for excavators, dozers, loaders, and graders on civil sites.',
    responsibilities: [
      'Operate heavy equipment for excavation, grading, and earthwork',
      'Perform daily equipment inspections and routine maintenance',
      'Coordinate with surveyors and superintendents on site work',
      'Follow site safety protocols at all times',
    ],
    requirements: [
      '5+ years heavy equipment operation experience',
      'CDL preferred',
      'Strong safety record',
      'Willingness to travel and work in varied conditions',
    ],
  },
];
